module.exports = __webpack_public_path__ + "userfiles/yoli/img/erweim.4f82cd3d.png";